import { ModuleManifest } from "shared/bootstrap";
import { VuePlugins } from "shared/bootstrap/types";
import publicLocale from "./i18n/public.json";
import adminLocale from "./i18n/admin.json";

const manifest: ModuleManifest = {
  localisation: { key: "feedback", messages: publicLocale },
};
export default manifest;

export const AdminManifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "feedback" },
      title: "feedback.menuItems.feedback",
      icon: "bullhorn",
    },
  ],
  routes: [
    {
      path: "/feedback",
      name: "feedback",
      meta: {
        title: "feedback.menuItems.feedback",
      },
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      component: () => import("./pages/Feedback.vue"),
    },
  ],
  vuePlugins: [VuePlugins.CompendaIntegration],
  localisation: { key: "feedback", messages: adminLocale },
};
